// get this dynamically afterwards
const user = {
	userToken: 'USER_TOKEN_WILL_BE_HERE',
}

const UserContext = ({ children }) => {
	if (typeof children !== 'function') return children
	return children(user)
}

export default UserContext
